"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _SingleValue = require("./SingleValue");

var _default = _SingleValue.SingleValue;
exports["default"] = _default;